<script>
import { onMounted,provide,reactive } from 'vue';
import { useRoute } from "vue-router";

//composable
import LandingFlow from "../composable/LandingFlow";
//controller
import { DetailController } from '../controller/DetailController';
import { RedeemController } from '../controller/RedeemController';
//component
import Picture from '../component/Picture.vue'
import DetailInfo from '../component/DetailInfo.vue'
import DetailAndCondition from '../component/DetailAndCondition.vue'
import RedeemButton from '../component/RedeemButton.vue'
import { useTheme } from '../composable/IimpactTheme';
//Feature
import { useLocale } from '@/feature/LocaleFeature'
//store
import useModalStore from "../store/ModalStore";
//modal
import ModalMaster from "../modal/ModalMaster.vue";
import { useModalSetup } from '../modal/useModalSetup'

export default {
    components: {
        ModalMaster,
        Picture,
        DetailInfo,
        DetailAndCondition,
        RedeemButton
    },
    setup: function () {
        useTheme()
        const { switchLang, lbl } = useLocale()
        const route = useRoute()

        const ModalStore = useModalStore()
        const { initModal } = useModalSetup(ModalStore)
        const modal = initModal();

        const landingFlow = LandingFlow({
            mainAppName: "iimmpact"
        })

        const detailController = new DetailController()
        const redeemController = new RedeemController()

        let immpact = reactive({
            isLoaded: false,
        })

        const init = () => {
            // start initial
            modal.loadingModal.show()
            landingFlow.init()
            landingFlow.events.onError = (err) => {
                console.log("init error", err)
                modal.loadingModal.hide()
            }
            landingFlow.events.onReady = () => {
                modal.loadingModal.hide()

                detailController.initial(landingFlow.states.campaign)
                redeemController.initial(landingFlow.states.campaign,
                                        modal,
                                        landingFlow.states.query.token,
                                        landingFlow.states.query.apiPrefix,
                                        landingFlow.states.blobWebLanding);
                immpact.isLoaded = true;
                console.log("isPageReady", landingFlow.states)
            }
        }

        const clickRedeem = () => {
            let selectCampaignId = detailController.selectedCampaignId;
            let selectedQuantity = detailController.selectedQuantity;
            redeemController.clickRedeem(selectCampaignId, selectedQuantity);
        }

        const clickBack = () => {
            window.location.replace(route.query.return_url);
        }


        provide("Modal", modal)
        provide("LandingFlow", landingFlow)

        onMounted(() => {
            if (route.query?.locale != null) {
                switchLang(route.query?.locale);
            }
            init()
        })

        return {
            lbl,
            modal,
            immpact,
            landingFlow,
            detailController,
            clickRedeem,
            clickBack
        }
    },
}
</script>
<template>
    <div class="font-main">
        <div class="mx-auto page">
            <div class="relative bg-primary-color text-secondary-color text-18 text-center font-bold py-5">
                <div>
                    {{lbl.iimmpact.detail.title}}
                </div>
                <div class="absolute top-0 left-0 w-full flex pt-5 pl-5">
                    <div class="w-5">
                        <img @click="clickBack()" src="../assets/icon/ic_iim-arrow-back.svg"/>
                    </div>
                </div>
            </div>
            <div v-if="immpact.isLoaded && landingFlow.states.campaign != null">
                <div class="p-5">
                    <Picture :campaign="landingFlow.states.campaign"></Picture>
                </div>
                <div class="px-5 pb-36">
                    <DetailInfo :campaign="landingFlow.states.campaign"></DetailInfo>
                    <DetailAndCondition :campaign="landingFlow.states.campaign"></DetailAndCondition>
                </div>
                <div class="wrapper-redeem-btn w-full fixed bottom-0 py-10 px-5 bg-white">
                    <RedeemButton
                        class="mt-2"
                        :detailController="detailController"
                        :landingFlow="landingFlow"
                        @clickRedeem="clickRedeem()"
                    ></RedeemButton>
                </div>
            </div>
        </div>
        <ModalMaster :controller="modal" />
    </div>
</template>
<style lang="scss" >
    @import "../style/main.scss";
</style>
<style lang="scss" scoped>
    @import "../style/base/base.scss";
    .wrapper-redeem-btn {
        max-width: $max-width-mobile;
    }
</style>
